import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 38px;
  padding: 5px;
  border-radius: 0.5rem;
  border: none;
  background-color: #f1f1f1;
  color: #626262;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: #cbcacb;
  }
  :-ms-input-placeholder {
    color: #cbcacb;
  }
`;

export const Message = styled.h2`
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;
